import React from "react";

import "antd/dist/antd.css";

import { Row, Col, Card, CardImg, Container } from "react-bootstrap";

import Spinner from "../utilities/Spinner.jsx";
import ImageViewer from "../utilities/ImageViewer.jsx";

function Trending({ data }) {
  console.log(data);

  return (
    <Container>
      {!data ? (
        <Spinner />
      ) : (
        <Row>
          <Col sm={8}>
            <Row>
              {data.map((event) => {
                return (
                  <Col
                    sm={12}
                    className="my-4"
                    key={event.id}
                    data-aos="fade-up"
                  >
                    <Card>
                      <Row>
                        <ImageViewer
                          gallery={event.gallery.filter(
                            (photo) => Number(photo.trending) === 1
                          )}
                        />
                      </Row>

                      <Card.Title>{event.event_title}</Card.Title>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </Col>

          <Col sm={4}>
            <Row style={{ position: "sticky", top: "5rem" }}>
              {
                <Col sm={12} className="my-4">
                  <CardImg
                    src={`${data[0].gallery[0].image.replace("media","static")}`}
                  />
                </Col>
              }
            </Row>
          </Col>
        </Row>
      )}
    </Container>
  );
}

export default Trending;
